import React from 'react'
import constants from "../constants";
import service from "../css/service.module.css";

const Footer = () => {

	return (
		<>
			<footer>
				<div className="wrp">
					<div>
						<div className="logo" data-href="/"></div>
					</div>
					<div className="bottom">
						<div>
							<ul className="acp">
								<li>(주)핀테크</li>
								<li>대표자 김갑영 ∣ 사업자등록번호 113-86-53976</li>
								<li>07251 서울특별시 영등포구 영신로 166, 9층(영등포동6가, 영등포 반도아이비밸리)</li>
								<li>전화 02-6956-4148 (09:00 ~ 18:00) ∣ 이메일 <a
									href="mailto:contact@fintech1.co.kr">contact@fintech1.co.kr</a></li>
							</ul>
							<ul className="terms">
								<li><a href="/privacyTerms">개인정보 처리방침</a></li>
							</ul>
							<p className="cpr">Copyright &copy; FINTECH INC. All rights reserved.</p>
						</div>
						<div>
							<div className="links">
								<span className="tit">파피노스 앱 다운로드</span>
								<div className="service">
									<a href={constants.papaynosGooglePlayUrl} target="_blank" rel="noreferrer" className={`${service['btn-bg']} ${service.gray} ${service.icon}`}><i className={service['icon-google-play']}></i><span>구글플레이</span></a>
									<a href={constants.papaynosAppStoreUrl} target="_blank" rel="noreferrer" className={`${service['btn-bg']} ${service.gray} ${service.icon}`}><i className={service['icon-app-store']}></i><span>앱스토어</span></a>
								</div>
							</div>
							<div className="links">
								<span className="tit">모니 앱 다운로드</span>
								<div className="service">
									<a href={constants.monneyGooglePlayUrl} target="_blank" rel="noreferrer" className={`${service['btn-bg']} ${service.gray} ${service.icon}`}><i className={service['icon-google-play']}></i><span>구글플레이</span></a>
									<a href={constants.monneyAppStoreUrl} target="_blank" rel="noreferrer" className={`${service['btn-bg']} ${service.gray} ${service.icon}`}><i className={service['icon-app-store']}></i><span>앱스토어</span></a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</footer>
		</>
	)
}

export default Footer
